<template>
  <div class="wiki">
    <v-card elevation="0" class="cardWiki">
      <v-card-title class="wikiTitle"> F A Q </v-card-title>
      <div class="wikiExpansion">
        <v-expansion-panels multiple>
          <!-- Start forgot password -->
          <v-expansion-panel>
            <v-expansion-panel-header class="text-h6">{{
              $t("wiki.resetPassword.title")
            }}</v-expansion-panel-header>
            <v-expansion-panel-content class="wikiExpansionDetails">
              <div>
                {{ $t("wiki.resetPassword.step1") }} <br /><br />
                <img
                  class="wikiImg"
                  src="@/assets/images/wiki/loginScreen.png"
                  alt="Image where to click for forgotten password"
                  width="auto"
                />
              </div>
              <br />
              <div>
                {{ $t("wiki.resetPassword.step2") }} <br /><br />
                <img
                  class="wikiImg"
                  src="@/assets/images/wiki/forgot1.png"
                  alt="First step for resetting password"
                  width="auto"
                />
              </div>
              <br />
              <div>
                {{ $t("wiki.resetPassword.step3") }} <br /><br />
                <img
                  class="wikiImg"
                  src="@/assets/images/wiki/forgot2.png"
                  alt="Second step for resetting password"
                  width="auto"
                />
              </div>
              <br />
              <div>
                {{ $t("wiki.resetPassword.step4") }} <br /><br />
                <img
                  class="wikiImg"
                  src="@/assets/images/wiki/forgot3.png"
                  alt="Last step for resetting password"
                  width="auto"
                />
                <br />
                {{ $t("wiki.resetPassword.step5") }}
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <!-- End forgot password -->

          <!-- Start add an event -->
          <v-expansion-panel>
            <v-expansion-panel-header class="text-h6">
              {{ $t("wiki.addEvent.title") }}</v-expansion-panel-header
            >
            <v-expansion-panel-content class="wikiExpansionDetails">
              <div>
                {{ $t("wiki.addEvent.step0") }} <br /><br />
                <img
                  class="wikiImg"
                  src="@/assets/images/wiki/addEvent.png"
                  alt="How to add event"
                  width="90%"
                />
                <br />
              </div>
              <div>
                {{ $t("wiki.addEvent.step1") }} <br /><br />
                <img
                  class="wikiImg"
                  src="@/assets/images/wiki/addEvent1.png"
                  alt="First step for adding event"
                  width="auto"
                />
                <br />
              </div>
              <div>
                {{ $t("wiki.addEvent.step2") }}
                <br /><br />
                <img
                  class="wikiImg"
                  src="@/assets/images/wiki/addEvent2.png"
                  alt="Second step for adding event"
                  width="auto"
                />
                <br />
              </div>
              <div>
                {{ $t("wiki.addEvent.step3") }}
                <br /><br />
                <img
                  class="wikiImg"
                  src="@/assets/images/wiki/addEvent3.png"
                  alt="Third step for adding event"
                  width="auto"
                />
                <br />
              </div>
              <div>
                {{ $t("wiki.addEvent.step4") }} <br /><br />
                <img
                  class="wikiImg"
                  src="@/assets/images/wiki/addEvent4.png"
                  alt="Last step for adding event"
                  width="auto"
                />
                <br />
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <!-- End add an event -->

          <!-- Start update an event -->
          <v-expansion-panel>
            <v-expansion-panel-header class="text-h6">
              {{ $t("wiki.updateEvent.title") }}
            </v-expansion-panel-header>
            <v-expansion-panel-content class="wikiExpansionDetails">
              <v-row>
                <v-col>
                  <div class="text-overline">
                    {{ $t("wiki.updateEvent.titleCard") }}
                  </div>
                  <div>
                    {{ $t("wiki.updateEvent.stepCard1") }}
                    <br /><br />
                    <img
                      class="wikiImg"
                      src="@/assets/images/wiki/updateEventCard1.png"
                      alt="Third step for adding event"
                      width="auto"
                    />
                    <br />
                  </div>
                  <div>
                    {{ $t("wiki.updateEvent.stepCard2") }}
                    <br /><br />
                    <img
                      class="wikiImg"
                      src="@/assets/images/wiki/updateEventCard2.png"
                      alt="Third step for adding event"
                      width="auto"
                    />
                    <br />
                  </div>
                </v-col>
                <v-divider vertical></v-divider>
                <v-col>
                  <div class="text-overline">
                    {{ $t("wiki.updateEvent.titleDrag") }}
                  </div>
                  <div>
                    {{ $t("wiki.updateEvent.stepDrag1") }}
                    {{ $t("wiki.updateEvent.stepDrag2") }}
                    <br /><br />
                    <img
                      class="wikiImg"
                      src="@/assets/images/wiki/updateEventDrag1.png"
                      alt="Third step for adding event"
                      width="auto"
                    />
                    <br />
                  </div>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <!-- End update an event -->

          <!-- Start delete an event -->
          <v-expansion-panel>
            <v-expansion-panel-header class="text-h6">{{
              $t("wiki.deleteEvent.title")
            }}</v-expansion-panel-header>
            <v-expansion-panel-content class="wikiExpansionDetails">
              <div>
                {{ $t("wiki.deleteEvent.step1") }} <br /><br />
                <img
                  class="wikiImg"
                  src="@/assets/images/wiki/deleteEvent1.png"
                  alt="First step for deleting event"
                  width="90%"
                />
                <br />
              </div>
              <div>
                {{ $t("wiki.deleteEvent.step2") }} <br /><br />
                <img
                  class="wikiImg"
                  src="@/assets/images/wiki/deleteEvent2.png"
                  alt="Second step for deleting event"
                  width="90%"
                />
                <br />
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <!-- End delete an event -->

          <!-- Start move in the planning -->
          <v-expansion-panel>
            <v-expansion-panel-header class="text-h6">{{
              $t("wiki.updatePlanning.title")
            }}</v-expansion-panel-header>
            <v-expansion-panel-content class="wikiExpansionDetails">
              <v-row>
                <v-col>
                  <div class="text-overline">
                    {{ $t("wiki.updatePlanning.step1") }}
                  </div>
                  <div>
                    {{ $t("wiki.updatePlanning.step1Text") }}
                  </div>
                </v-col>
                <v-divider vertical></v-divider>
                <v-col>
                  <div class="text-overline">
                    {{ $t("wiki.updatePlanning.step2") }}
                  </div>
                  <div>
                    {{ $t("wiki.updatePlanning.step2TextPart1") }}
                  </div>
                  <div>
                    {{ $t("wiki.updatePlanning.step2TextPart2") }}
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <div class="text-overline">
                    {{ $t("wiki.updatePlanning.step3") }}
                  </div>
                  <div>
                    {{ $t("wiki.updatePlanning.step3Text") }}
                  </div>
                </v-col>
                <v-divider vertical></v-divider>
                <v-col>
                  <div class="text-overline">
                    {{ $t("wiki.updatePlanning.step4") }}
                  </div>
                  <div>
                    {{ $t("wiki.updatePlanning.step4Text") }}
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <div @click="toggleFullscreen($refs.changeCalendar)">
                  <img
                    ref="changeCalendar"
                    class="wikiImg"
                    src="@/assets/images/wiki/planningOption.png"
                    alt="Image where to click to change calendar"
                    width="90%"
                  />
                </div>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <!-- End move in the planning -->

          <!-- Start add element in the CRUD -->
          <v-expansion-panel>
            <v-expansion-panel-header class="text-h6">
              {{ $t("wiki.addCrud.title") }}
            </v-expansion-panel-header>
            <v-expansion-panel-content class="wikiExpansionDetails">
              <div class="text-overline">
                {{ $t("wiki.addCrud.step0") }}
              </div>
              <div>{{ $t("wiki.addCrud.step1") }}</div>
              <div>
                <div>
                  <br /><br />
                  <img
                    ref="addBtn"
                    class="wikiImg"
                    src="@/assets/images/wiki/addCourseCrud.png"
                    alt="add step 1"
                    width="100%"
                  />
                </div>
                <br /><br />
                <div>{{ $t("wiki.addCrud.step2") }}</div>
                <div @click="toggleFullscreen($refs.addBtn)">
                  <br /><br />
                  <img
                    ref="addBtn"
                    class="wikiImg"
                    src="@/assets/images/wiki/crud/addBtn.png"
                    alt="add step 2"
                    width="100%"
                  />
                </div>
                <div @click="toggleFullscreen($refs.addForm)">
                  <img
                    ref="addForm"
                    class="wikiImg"
                    src="@/assets/images/wiki/crud/addForm.png"
                    alt="add step 3"
                    width="50%"
                  />
                </div>
                <div>
                  <div @click="toggleFullscreen($refs.addConfirmed)">
                    <img
                      ref="addConfirmed"
                      class="wikiImg"
                      src="@/assets/images/wiki/crud/addConfirmed.png"
                      alt="add step 4"
                      width="45%"
                    />
                  </div>
                  <div @click="toggleFullscreen($refs.addError)">
                    <img
                      ref="addError"
                      class="wikiImg"
                      src="@/assets/images/wiki/crud/addError.png"
                      alt="add step 1"
                      width="45%"
                    />
                  </div>
                </div>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel>
            <v-expansion-panel-header class="text-h6">
              {{ $t("wiki.editCrud.title") }}
            </v-expansion-panel-header>
            <v-expansion-panel-content class="wikiExpansionDetails">
              <div class="text-overline">
                <p>
                  {{ $t("wiki.editCrud.subTitle") }}
                </p>
              </div>
              <div class="text">
                <p>- 1 {{ $t("wiki.editCrud.step1") }}</p>
                <p>- 2 {{ $t("wiki.editCrud.step2") }}</p>
                <p>- 3 {{ $t("wiki.editCrud.step3") }}</p>
              </div>

              <div>
                <video
                  controls
                  class="wikiImg"
                  src="@/assets/images/wiki/edit/edit.mp4"
                  alt="add step 1"
                  width="100%"
                />
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <!-- End add element in the CRUD -->

          <!-- Start delete element in the CRUD -->
          <v-expansion-panel>
            <v-expansion-panel-header class="text-h6"
              >{{ $t("wiki.deleteCrud.title") }}
            </v-expansion-panel-header>
            <v-expansion-panel-content class="wikiExpansionDetails">
              <div class="text-overline">
                {{ $t("wiki.deleteCrud.step0") }}
              </div>
              <div>
                {{ $t("wiki.addCrud.step1") }}
              </div>
              <div>
                <br /><br />
                <img
                  ref="addBtn"
                  class="wikiImg"
                  src="@/assets/images/wiki/addCourseCrud.png"
                  alt="Delete step 1"
                  width="70%"
                />
              </div>
              <br /><br />
              <div>
                {{ $t("wiki.addCrud.step2") }}
              </div>
              <div>
                <br /><br />
                <img
                  ref="addBtn"
                  class="wikiImg"
                  src="@/assets/images/wiki/crud/deleteCrud1.png"
                  alt="Delete step 2"
                  width="70%"
                />
              </div>
              <br /><br />
              <div>
                {{ $t("wiki.deleteCrud.step3") }}
              </div>
              <div>
                <br /><br />
                <img
                  ref="addBtn"
                  class="wikiImg"
                  src="@/assets/images/wiki/crud/promptDelete.png"
                  alt="Delete step 3"
                  width="40%"
                />
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <!-- End delete element in the CRUD -->

          <!-- Start update with Wdg2 -->
          <v-expansion-panel>
            <v-expansion-panel-header class="text-h6">
              {{ $t("wiki.updateCrudDg2.title") }}
            </v-expansion-panel-header>
            <v-expansion-panel-content class="wikiExpansionDetails">
              <div>{{ $t("wiki.updateCrudDg2.step1") }}</div>
              <br />
              <div>
                <img
                  class="wikiImg"
                  src="@/assets/images/wiki/updateWithWebservice.png"
                  alt="Image where to click for Dawan webservice"
                  width="90%"
                />
              </div>
              <br />
              <div>{{ $t("wiki.updateCrudDg2.step2") }}</div>
              <br />
              <div>
                <img
                  class="wikiImg"
                  src="@/assets/images/wiki/updateCrudDg2.png"
                  alt="Login form to update list"
                  width="40%"
                />
              </div>
              <br />
            </v-expansion-panel-content>
          </v-expansion-panel>
          <!-- End update with Wdg2 -->

          <!-- Start data storage event -->
          <v-expansion-panel>
            <v-expansion-panel-header class="text-h6">{{
              $t("wiki.seeMemento.title")
            }}</v-expansion-panel-header>
            <v-expansion-panel-content class="wikiExpansionDetails">
              <v-row>
                <v-col>
                  <div class="text-overline">
                    {{ $t("wiki.seeMemento.downloadCsv") }}
                  </div>
                  <div>
                    {{ $t("wiki.seeMemento.downloadCsvText") }}
                  </div>
                  <br />
                  <div @click="toggleFullscreen($refs.wikiCsv)">
                    <img
                      ref="wikiCsv"
                      class="wikiImg"
                      src="@/assets/images/wiki/csv.png"
                      alt="Image where to click to download event modifications"
                      width="100%"
                    />
                  </div>
                </v-col>
                <v-divider vertical></v-divider>
                <v-col>
                  <div class="text-overline">
                    {{ $t("wiki.seeMemento.mementoPage") }}
                  </div>
                  <div>
                    {{ $t("wiki.seeMemento.mementoPagePart1") }}
                  </div>
                  <div>
                    {{ $t("wiki.seeMemento.mementoPagePart2") }}
                  </div>
                  <br />
                  <div @click="toggleFullscreen($refs.wikiMemento)">
                    <img
                      ref="wikiMemento"
                      class="wikiImg"
                      src="@/assets/images/wiki/memento.png"
                      alt="Image where to click to see event modifications"
                      width="100%"
                    />
                  </div>
                  <br />
                  <div>
                    {{ $t("wiki.seeMemento.mementoPagePart3") }}
                  </div>
                  <br />
                  <div @click="toggleFullscreen($refs.wikiIdEvent)">
                    <img
                      ref="wikiIdEvent"
                      class="wikiImg"
                      src="@/assets/images/wiki/idEvent.png"
                      alt="Image to know where to find event id"
                      width="100%"
                    />
                  </div>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <!-- End data storage event -->

          <!-- Start data storage event -->
          <v-expansion-panel>
            <v-expansion-panel-header class="text-h6">
              {{ $t("wiki.restoreMemento.title") }}
            </v-expansion-panel-header>
            <v-expansion-panel-content class="wikiExpansionDetails">
              <div>
                {{ $t("wiki.restoreMemento.intro") }}
              </div>
              <br />
              <div>
                <span
                  class="text-subtitle-2"
                  v-bind:style="{ color: '#E53935' }"
                  >{{ $t("wiki.restoreMemento.step1") }}</span
                >{{ $t("wiki.restoreMemento.step1Text") }}
              </div>
              <div>
                <span
                  class="text-subtitle-2"
                  v-bind:style="{ color: '#E53935' }"
                  >{{ $t("wiki.restoreMemento.step2") }}</span
                >{{ $t("wiki.restoreMemento.step2Text") }}
              </div>
              <div class="font-italic">
                {{ $t("wiki.restoreMemento.step2Comment") }}
              </div>
              <div>
                <span
                  class="text-subtitle-2"
                  v-bind:style="{ color: '#E53935' }"
                  >{{ $t("wiki.restoreMemento.step3") }}</span
                >{{ $t("wiki.restoreMemento.step3Text") }}
              </div>
              <br />
              <div>{{ $t("wiki.restoreMemento.end") }}</div>
              <br />
              <div @click="toggleFullscreen($refs.wikiRestore)">
                <img
                  ref="wikiRestore"
                  class="wikiImg"
                  src="@/assets/images/wiki/restoreMemento.png"
                  alt="Image to know where to click to restore a previous state from an event"
                  width="90%"
                />
              </div>
              <br />
              <div>
                {{ $t("wiki.restoreMemento.comment") }}
              </div>
              <br />
              <div @click="toggleFullscreen($refs.wikiIdEvent2)">
                <img
                  ref="wikiIdEvent2"
                  class="wikiImg"
                  src="@/assets/images/wiki/idEvent.png"
                  alt="Image to know where to find event id"
                  width="90%"
                />
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <!-- End data storage event -->

          <!-- Start send email -->
          <v-expansion-panel>
            <v-expansion-panel-header class="text-h6">
              {{ $t("wiki.sendPlanningMail.title") }}
            </v-expansion-panel-header>
            <v-expansion-panel-content class="wikiExpansionDetails">
              <div>{{ $t("wiki.sendPlanningMail.step1") }}</div>
              <br /><br />
              <div>
                <img
                  class="wikiImg"
                  src="@/assets/images/wiki/sendMailButton.png"
                  alt="Location of Mail button"
                  width="70%"
                />
              </div>
              <br /><br />
              <div>{{ $t("wiki.sendPlanningMail.step2") }}</div>
              <br /><br />
              <div>
                <img
                  class="wikiImg"
                  src="@/assets/images/wiki/sendPlanningMail.png"
                  alt="Sending mail form"
                  width="70%"
                />
              </div>
              <br /><br />
            </v-expansion-panel-content>
          </v-expansion-panel>
          <!-- End send email -->

          <!-- Start update options -->
          <v-expansion-panel>
            <v-expansion-panel-header class="text-h6">
              {{ $t("wiki.changeMode.title") }}
            </v-expansion-panel-header>
            <v-expansion-panel-content class="wikiExpansionDetails">
              <v-row>
                <v-col>
                  <div class="text-overline">
                    {{ $t("wiki.changeMode.titleDarkMode") }}
                  </div>
                  <br />
                  <div>{{ $t("wiki.changeMode.darkModeStep1") }}</div>
                  <div>
                    <img
                      class="wikiImg"
                      src="@/assets/images/wiki/changeModes.png"
                      alt="Screen for changing modes"
                      width="100%"
                    />
                  </div>
                  <br />
                  <div>{{ $t("wiki.changeMode.darkModeStep2") }}</div>
                  <div>
                    <img
                      class="wikiImg"
                      src="@/assets/images/wiki/darkMode.png"
                      alt="Screen of Dark Mode"
                      width="100%"
                    />
                  </div>
                </v-col>
                <v-divider vertical></v-divider>
                <v-col>
                  <div class="text-overline">
                    {{ $t("wiki.changeMode.changeLanguage") }}
                  </div>
                  <br />
                  <div>{{ $t("wiki.changeMode.language1") }}</div>
                  <div>
                    <img
                      class="wikiImg"
                      src="@/assets/images/wiki/changeModes.png"
                      alt="Screen for changing modes"
                      width="100%"
                    />
                  </div>
                  <br />
                   <div>{{ $t("wiki.changeMode.language2") }}</div>
                  <div>
                    <img
                      class="wikiImg"
                      src="@/assets/images/wiki/englishMode.png"
                      alt="Screen of the english version"
                      width="100%"
                    />
                  </div>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <!-- End update options -->
        </v-expansion-panels>
      </div>
    </v-card>
  </div>
</template>

<script>
export default {
  props: [],
  components: {},
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {
    toggleFullscreen(element) {
      if (document.fullscreenElement) {
        return document.exitFullscreen(); // exit fullscreen on next click
      }
      if (element.requestFullscreen) {
        element.requestFullscreen();
      } else if (this.element.webkitRequestFullscreen) {
        element.webkitRequestFullscreen(); // Safari
      } else if (this.element.msRequestFullscreen) {
        element.msRequestFullscreen(); // IE11
      }
    },
  },
};
</script>

<style>
.wiki {
  margin-top: 2rem;
  width: 80%;
}

.cardWiki {
  margin-bottom: 5rem;
  display: flex;
  justify-content: center;
  flex-direction: column;
  width: 100%;
}

.wikiTitle {
  margin: 2rem;
  display: flex;
  justify-content: center;
}

.wikiExpansion {
  margin: 0 5rem 5rem 5rem;
}

.wikiImg {
  display: block;
  margin-left: auto;
  margin-right: auto;
}
</style>
